<h1 mat-dialog-title>{{'subscription.restartFormDialog.title' | translate}}</h1>
<mat-dialog-content>
  {{'subscription.restartFormDialog.message' | translate}}
  <br/>
  <div [innerHTML]="errorMessage">
  </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end">
  <button color="primary"
          mat-raised-button
          (click)="save()">
          {{'subscription.okButton' | translate}}</button>
</mat-dialog-actions>
